import { dateCalc, dateFormat, parseDate } from '@mirai/locale';

export const calcToDate = (dates = [], rangeMaxDays) => {
  return dates.length > 0 ? dateFormat(dateCalc(parseDate([...dates].pop()), rangeMaxDays, 'days')) : undefined;
};
